import { Component, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ForgotPasswordService } from '@shared/services/forgot-password.service';
import { SnackbarFactory, ThemeService } from '@shared/services';

@Component({
  selector: 'app-forgot-password-confirmation',
  templateUrl: './forgot-password-confirmation.component.html',
  styleUrls: ['./forgot-password-confirmation.component.scss'],
})
export class ForgotPasswordConfirmationComponent {
  private username: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public forgotPwdService: ForgotPasswordService,
    private translate: TranslateService,
    private snackBar: SnackbarFactory,
    public themeService: ThemeService,
    @Inject('EMAIL_SERVER_ACTIVE') public EMAIL_SERVER_ACTIVE: boolean,
  ) {
    this.username = this.route.snapshot.queryParamMap.get('username');
  }

  backToLogin() {
    this.router.navigateByUrl('/login', { replaceUrl: true });
  }

  resendLink() {
    if (this.EMAIL_SERVER_ACTIVE) {
      this.forgotPwdService.requestPwdChange(this.username, false).subscribe({
        complete: () => {
          this.snackBar.showButtonSnackbarWithText(200, this.translate.instant('pwd-email-sent'))
        },
        error: (err) => {
          this.snackBar.showButtonSnackbar(err);
        },
      });
    }
  }

}
